












// @ts-nocheck
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getTypeAreaListReq } from '@/services/uploads'

@Component({})
export default class VideoClassify extends Vue {
  tagTypeList: Array<any> = []
  selectedOptions: Array<any> = []
  timer: any
  typeId: number = 0

  @Prop() formData?: UploadVideoAPI.UploadFrom

  mounted() {
    this.getTagListData()
  }
  async getTagListData() {
    const req = await getTypeAreaListReq({})
    if (req.code === 200 && req.data.length > 0) {
      this.tagTypeList = this.formatTagData(req.data)
    }
  }

  formatTagData(data: any) {
    const arr = []
    for (let i = 0; i < data.length; i += 1) {
      const item = data[i]
      arr[i] = {}
      arr[i].value = item.typeId
      arr[i].label = item.typeName
      arr[i].showmode = item.showmode
      arr[i].tagCategory = item.tagCategory
      arr[i].classId = item.classId
      if (item.areaList && item.areaList.length > 0) {
        arr[i].children = []
        for (let k = 0; k < item.areaList.length; k += 1) {
          const child = item.areaList[k]
          arr[i].children.push({
            value: child.areaId,
            label: `${child.areaName}`,
            areaDesc: `${child.areaDesc}`,
          })
        }
      }
    }
    this.timer = null
    this.timer = setTimeout(() => {
      this.appendDes()
    }, 500)
    return arr
  }

  // 处理二级联动菜单的描述
  appendDes() {
    const parent = document.getElementsByClassName('el-cascader-menu')[1]
    if (parent) {
      const labelsArr = [].slice.call(
        document
          .getElementsByClassName('el-cascader-menu')[1]
          .getElementsByClassName('el-cascader-node__label')
      )
      let arrDes = []
      for (let i = 0; i < this.tagTypeList.length; i += 1) {
        if (this.tagTypeList[i].value === this.typeId) {
          arrDes = this.tagTypeList[i].children
        }
      }
      for (let i = 0; i < labelsArr.length; i += 1) {
        const insertDom = document.createElement('span')
        insertDom.className = 'areaDes'
        insertDom.innerHTML = `${arrDes[i].areaDesc}`
        labelsArr[i].appendChild(insertDom)
      }
    }
  }

  handleChange(value: number[]) {
    if (value) {
      this.formData.typearea = value
      this.formData.areaid = value[1]
      this.bus.$emit('setTag', 'changeArea')
    }
  }

  getShowMode(typeId) {
    const temp = this.tagTypeList.filter(item => item.value === typeId)
    this.$emit('updateShowMode', temp[0])
  }

  itemChange(value: number[]) {
    this.getShowMode(value[0])
    this.typeId = value[0]
    this.timer = null
    this.timer = setTimeout(() => {
      this.appendDes()
    }, 100)
  }
}
